import { Box, FlexProps, Text } from "@chakra-ui/react";
import { getComponentStyle } from "components/containers/InspectionFormat/Content/SettingFontSize/utils/style";
import { PinComponentStyle } from "interfaces/models/pinComponent";
import { memo, useMemo } from "react";

const BlackboardContentText = (params: {
  value: any;
  style: PinComponentStyle | undefined;
  zoomRatio: number;
  boxProps?: FlexProps;
}) => {
  const { value, style, zoomRatio, boxProps } = params;
  const { alignItems, lineHeight, fontSize, ...newStyle } = useMemo(
    () => getComponentStyle(style),
    [style]
  );

  return (
    <Box
      {...newStyle}
      display="grid"
      placeItems={alignItems}
      height="100%"
      width="100%"
      position="relative"
      {...boxProps}
    >
      <Text
        width="100%"
        height="fit-content"
        fontSize={`${fontSize * zoomRatio}px`}
        display="inline-block"
      >
        {typeof value === "string" ? value : ""}
      </Text>
    </Box>
  );
};

export default memo(BlackboardContentText);
